/* DM Living Theme JS */
(function() {
  'use strict';

  /* Announcement Bar Close */
  document.querySelectorAll('.announcement-bar__close').forEach(btn => {
    btn.addEventListener('click', () => btn.closest('.announcement-bar').remove());
  });

  /* Mobile Menu Toggle */
  /* Mobile Dropdown Fix */
document.querySelectorAll(".header__mobile-item.has-submenu > .header__mobile-link")
  .forEach(link => {
    link.addEventListener("click", function(e) {

      e.preventDefault();

      // बाकी सब close करो (optional)
      document.querySelectorAll(".header__mobile-item")
        .forEach(item => {
          if (item !== this.parentElement) {
            item.classList.remove("active");
          }
        });

      // current toggle
      this.parentElement.classList.toggle("active");

    });
  });
  const menuToggle = document.getElementById('mobileMenuToggle');
  const mobileMenu = document.getElementById('mobileMenu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('hidden');
      menuToggle.querySelector('.icon-menu').classList.toggle('hidden');
      menuToggle.querySelector('.icon-close').classList.toggle('hidden');
    });
  }

  /* Search Toggle */
  const searchToggle = document.getElementById('searchToggle');
  const searchBar = document.getElementById('searchBar');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', () => {
      searchBar.classList.toggle('hidden');
      const input = searchBar.querySelector('input');
      if (input && !searchBar.classList.contains('hidden')) input.focus();
    });
  }

  /* Hero Slider */
  document.querySelectorAll('.hero-slider').forEach(slider => {
    const slides = slider.querySelectorAll('.hero-slider__slide');
    const dots = slider.querySelectorAll('.hero-slider__dot');
    if (slides.length < 2) return;
    let current = 0;
    const show = (i) => {
      slides.forEach((s, idx) => s.classList.toggle('active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('active', idx === i));
      current = i;
    };
    slider.querySelector('.hero-slider__arrow--prev')?.addEventListener('click', () => show((current - 1 + slides.length) % slides.length));
    slider.querySelector('.hero-slider__arrow--next')?.addEventListener('click', () => show((current + 1) % slides.length));
    dots.forEach(d => d.addEventListener('click', () => show(+d.dataset.index)));
    setInterval(() => show((current + 1) % slides.length), 5000);
  });

  /* Product Sliders */
  document.querySelectorAll('.product-slider__arrows').forEach(arrows => {
    const track = arrows.closest('.product-slider-section')?.querySelector('[data-slider]');
    if (!track) return;
    arrows.querySelectorAll('.slider-arrow').forEach(btn => {
      btn.addEventListener('click', () => track.scrollBy({ left: +btn.dataset.dir * 320, behavior: 'smooth' }));
    });
  });

  /* Testimonials */
  document.querySelectorAll('.testimonials').forEach(section => {
    const items = section.querySelectorAll('.testimonials__item');
    const dots = section.querySelectorAll('.testimonials__dot');
    if (items.length < 2) return;
    let current = 0;
    const show = (i) => {
      items.forEach((el, idx) => el.classList.toggle('active', idx === i));
      dots.forEach((d, idx) => d.classList.toggle('active', idx === i));
      current = i;
    };
    section.querySelector('.testimonial-prev')?.addEventListener('click', () => show((current - 1 + items.length) % items.length));
    section.querySelector('.testimonial-next')?.addEventListener('click', () => show((current + 1) % items.length));
    dots.forEach(d => d.addEventListener('click', () => show(+d.dataset.index)));
  });

  /* Back to Top */
  const backToTop = document.getElementById('backToTop');
  if (backToTop) {
    window.addEventListener('scroll', () => backToTop.classList.toggle('visible', window.scrollY > 400));
    backToTop.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  /* Product Page: Image Gallery */
  document.querySelectorAll('.product-page__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mediaId = thumb.dataset.mediaId;
      thumb.closest('.product-page__gallery').querySelectorAll('.product-page__media').forEach(m => m.classList.toggle('active', m.dataset.mediaId === mediaId));
      thumb.closest('.product-page__thumbs').querySelectorAll('.product-page__thumb').forEach(t => t.classList.toggle('active', t === thumb));
    });
  });

  /* Product Page: Variant Options */
  document.querySelectorAll('.product-page__option-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.product-page__option-values').querySelectorAll('.product-page__option-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const label = btn.closest('.product-page__option')?.querySelector('.product-page__option-value');
      if (label) label.textContent = btn.dataset.optionValue;
      updateVariant();
    });
  });

  function updateVariant() {
    const section = document.querySelector('.product-page');
    if (!section) return;
    const jsonEl = document.querySelector('[id^="product-json-"]');
    if (!jsonEl) return;
    try {
      const product = JSON.parse(jsonEl.textContent);
      const selected = [];
      section.querySelectorAll('.product-page__option-values').forEach(group => {
        const active = group.querySelector('.product-page__option-btn.active');
        if (active) selected.push(active.dataset.optionValue);
      });
      const variant = product.variants.find(v => v.options.every((o, i) => o === selected[i]));
      if (variant) {
        document.getElementById('productVariantId').value = variant.id;
      }
    } catch(e) {}
  }

  /* Product Page: Quantity */
  document.querySelectorAll('.product-page__qty-btn[data-qty]').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.product-page__qty').querySelector('.product-page__qty-input');
      if (input) input.value = Math.max(1, +input.value + +btn.dataset.qty);
    });
  });

  /* Product Page: FAQ Accordion */
  document.querySelectorAll('.product-page__faq-question').forEach(q => {
    q.addEventListener('click', () => q.closest('.product-page__faq-item').classList.toggle('open'));
  });

  /* Collection Filters Toggle */
  const filterToggle = document.getElementById('filterToggle');
  const filterSidebar = document.getElementById('filterSidebar');
  if (filterToggle && filterSidebar) {
    filterToggle.addEventListener('click', () => filterSidebar.classList.toggle('hidden'));
  }

  /* Collection Sort */
  const sortSelect = document.getElementById('sortSelect');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location = url;
    });
  }

  /* Product Card Size Selector */
  document.querySelectorAll('.product-card__size-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.product-card__sizes').querySelectorAll('.product-card__size-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

})();
